
import React from 'react';
import { Sparkles } from 'lucide-react';


// Navbar Component
const Navbar = ({ currentPage, onNavigate }) => {
  const isNavVisible = currentPage !== 'landing';
  
  // Don't render navbar on landing page
  if (!isNavVisible) {
    return null;
  }
  
  const navItems = [
    { id: 'home', label: 'Accueil' },
    { id: 'generator', label: 'Générateur' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-slate-900/95 via-purple-900/95 to-slate-900/95 backdrop-blur-xl border-b border-purple-500/20 shadow-lg">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-10">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <button 
            onClick={() => onNavigate('landing')}
            className="flex items-center space-x-3 hover:opacity-90 transition-opacity duration-200 group"
          >
            <div className="relative">
              <Sparkles className="w-8 h-8 text-purple-400 group-hover:text-pink-400 transition-colors duration-200" />
              <div className="absolute inset-0 blur-lg bg-gradient-to-r from-purple-400 to-pink-400 opacity-40 group-hover:opacity-60 transition-all duration-200" />
            </div>
            <div>
              <h1 className="text-xl font-bold bg-gradient-to-r from-purple-300 via-pink-300 to-purple-300 bg-clip-text text-transparent">
                PromptStudio
              </h1>
            </div>
          </button>
          
          {/* Navigation Links */}
          <div className="flex items-center space-x-2">
            {isNavVisible && navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className={`px-5 py-2 rounded-lg font-medium transition-all duration-300 ${
                  currentPage === item.id
                    ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/30'
                    : 'text-gray-200 hover:text-white hover:bg-white/10 hover:shadow-lg hover:shadow-purple-500/10'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;